module.exports = __webpack_public_path__ + "static/img/cybercrime_1.2364962c.png";